import { OperacoesWebAPI} from '../../utils/global';
import api from '../api'
export const pontoFiscalizacaoService = {
    
    getAllAtivosPorMunicipio: (municipioID: any) => {
        return api.get(`${OperacoesWebAPI.PontoFiscalizacao}/getallativopormunicipio`, { params: { municipioID } })
            .then((res) => res)
            .catch(err => err)
    },
    post:(pontoFiscalizacao:any) =>{

        return api.post(`${OperacoesWebAPI.PontoFiscalizacao}`,pontoFiscalizacao)
    },
    put:(pontoFiscalizacao:any) =>{
        return api.put(`${OperacoesWebAPI.PontoFiscalizacao}`,pontoFiscalizacao)
    },

    delete:(pontoFiscalizacaoID:number) =>{
        return api.delete(`${OperacoesWebAPI.PontoFiscalizacao}?id=${pontoFiscalizacaoID}`)
    }
}